/* eslint-disable  */
//@ts-nocheck
import { useCallback, useEffect, useState } from 'react';
import auth from '../auth';
import mux from '../video-library/mux';
import ajax from '../ajax';
import { useQuery } from '@apollo/client';
import { GET_INFLUENCER } from '@client/api/graphql/query';
import Spinner from '../Spinner';
import { ChatApi } from '@client/api/ChatApi';
import { Typography } from '@mui/material';
import * as styles from './SetupTab.css';

export const SetupTab = ({ influencerId }: { influencerId: number }) => {
  const [streamToken, setStreamToken] = useState(null);
  const [keyCopied, setKeyCopied] = useState(false);
  const [liveStreamKey, setLiveStreamKey] = useState(null);
  const [generatingStreamKey, setGeneratingStreamKey] = useState(false);

  const resetKey = useCallback(async () => {
    setGeneratingStreamKey(true);
    const {
      data: { stream_key },
    } = await mux.generateStreamKey({
      influencerId,
    });

    const prepareInfluencer = (i) => {
      if (!i.index || isNaN(i.index)) {
        i.index = 0;
      } else {
        i.index = parseInt(i.index);
      }
      return i;
    };

    const influencer = await ajax.getInfluencers(influencerId);
    influencer.liveStreamKey = stream_key;
    const preparedInfluencer = prepareInfluencer(influencer);
    await ajax.upsertInfluencer(preparedInfluencer);

    setLiveStreamKey(stream_key);
    setGeneratingStreamKey(false);
  }, [influencerId]);

  const isModerator = influencerId > 0;

  useEffect(() => {
    const getStreamToken = async () => {
      const token = isModerator
        ? await ChatApi.getModeratorChatToken({ creatorId: influencerId })
        : await ChatApi.getCreatorChatToken();
      setStreamToken(token);
    };

    (() => getStreamToken())();
  }, []);

  const { loading, error, data } = useQuery(GET_INFLUENCER, {
    variables: { id: influencerId },
    skip: !influencerId,
  });

  useEffect(() => {
    if (data) {
      setLiveStreamKey(data.creator.liveStreamKey);
    }
  }, [data]);

  if (!influencerId || loading) {
    return (
      <div className="p-5 md:p-10">
        <span>Loading...</span>
        <div className="row">
          <Spinner
            color={`#6367ef`}
            style={{ margin: 'auto', marginTop: '5px' }}
          />
        </div>
      </div>
    );
  }
  if (error) {
    return <span>Unknown error. Try again later</span>;
  }

  return (
    <>
      <div className={styles.streamBox}>
        <div className={styles.stack}>
          <span className={styles.title}>STREAM KEY</span>
          <button
            className={styles.smallButton({ success: !!keyCopied })}
            onClick={() => {
              navigator.clipboard.writeText(liveStreamKey);
              setKeyCopied(true);
              setTimeout(() => setKeyCopied(false), 3000);
            }}
          >
            {keyCopied ? 'COPIED!' : 'COPY'}
          </button>
        </div>
        {generatingStreamKey ? (
          <div className="row">
            <Spinner
              color={`#6367ef`}
              style={{ margin: 'auto', marginTop: '5px' }}
            />
          </div>
        ) : (
          <div className={styles.streamKey}>
            <input
              className={styles.streamKeyInput}
              type="text"
              value={liveStreamKey ?? ''}
              readOnly
            />
            <button className={styles.button} onClick={resetKey}>
              {liveStreamKey ? 'Reset' : 'Generate'}
            </button>
          </div>
        )}
      </div>

      <div className="pt-[40px]">
        <div className={styles.stack}>
          <span className={styles.title}>NEED HELP?</span>
        </div>
        <div className="flex space-x-[15px]">
          <a
            className={styles.needHelpTile}
            href="https://help.playbookapp.io/en/articles/11014431-how-to-livestream"
            target="_blank"
          >
            <Typography variant="h1">How to set up LiveStream</Typography>
            <h2>VISIT ARTICLE</h2>
          </a>
        </div>
      </div>
    </>
  );
};
